// extracted by mini-css-extract-plugin
var _1 = "TransferPostOwnershipModal-module__buttons--yLzZy";
var _2 = "TransferPostOwnershipModal-module__owner--xKR6a";
var _3 = "TransferPostOwnershipModal-module__ownerCard--Oblod";
var _4 = "TransferPostOwnershipModal-module__ownerHeading--ELs0z";
export { _1 as "buttons", _2 as "owner", _3 as "ownerCard", _4 as "ownerHeading" }
